/* Western Riding Co. v8 « Rodéo » — compléments du thème (le moteur v7 reste dans wrc.js : variantes, panier, filtres,
   calculateur, tiroir, recherche). Ici : chargement des pages suivantes d'une collection, scène produit (vignettes,
   mode atelier, variante → image), barre d'achat fixe (options, quantité, total), « Va bien avec ».
   v8.1 : calculateur de taille (initFit) et filtres de collection en barre d'outils / tiroir (initFilters). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  document.documentElement.classList.add('r-js');

  /* En-tête : reste visible au défilement (comme en v7). Plein : section collante, barre des promesses masquée.
     Transparent (accueil, collections) : passe en position fixe, fond nuit, une fois le haut du hero dépassé. */
  (function () {
    var h = document.querySelector('.r-hdr');
    if (!h || !h.parentElement) return;
    var util = h.querySelector('.r-util');
    function setU() { document.documentElement.style.setProperty('--r-utilh', (util ? util.offsetHeight : 0) + 'px'); }
    setU();
    addEventListener('resize', setU, { passive: true });
    if (!h.classList.contains('r-hdr--over')) { h.parentElement.classList.add('r-hdr-sticky'); return; }
    var on = false, raf = 0;
    function upd() { var s = scrollY > 140; if (s !== on) { on = s; h.classList.toggle('is-stuck', s); } }
    addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(upd); }, { passive: true });
    upd();
  })();

  /* ---------- Collection : « Afficher N produits de plus » ---------- */
  function initMore() {
    var grid = $('[data-r-grid]');
    if (!grid) return;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-r-more-btn]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      var label = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = btn.dataset.loading || label;
      fetch(btn.href, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = $$('[data-r-grid] > li.r-gi', doc);
        items.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
        var oldMore = $('[data-r-more]'), newMore = $('[data-r-more]', doc);
        if (oldMore && newMore) oldMore.replaceWith(document.importNode(newMore, true));
        else if (oldMore) oldMore.remove();
        var oldPag = $('.r-pag'), newPag = $('.r-pag', doc);
        if (oldPag && newPag) oldPag.replaceWith(document.importNode(newPag, true));
        var first = items[0] && grid.lastElementChild ? grid.children[grid.children.length - items.length] : null;
        if (first) { var a = $('a', first); if (a) a.focus({ preventScroll: true }); }
      }).catch(function () { window.location.href = btn.href; });
    });
  }


  /* ---------- Fiche produit : scène (vignettes, mode atelier, image de la variante), total, barre fixe, « Va bien avec » ---------- */
  function formatMoney(cents, format) {
    var value = cents / 100, fmt = format || '{{amount_with_comma_separator}} €';
    function sep(dec, thou) { var p = value.toFixed(2).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou); return p.join(dec); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return sep('.', ',');
        case 'amount_no_decimals': return Math.round(value).toLocaleString('en');
        case 'amount_with_comma_separator': return sep(',', '.');
        case 'amount_no_decimals_with_comma_separator': return Math.round(value).toLocaleString('de');
        case 'amount_with_space_separator': return sep(',', ' ');
        default: return sep(',', ' ');
      }
    });
  }
  function initProduct() {
    var wrap = $('[data-r-product]');
    if (!wrap) return;
    var money = wrap.dataset.money;
    var variants = [];
    try { variants = JSON.parse(($('[data-w-variants]', wrap) || {}).textContent || '[]'); } catch (e) {}
    var form = $('[data-w-product-form]', wrap);
    var stage = $('[data-r-stage]', wrap);
    var atBtn = $('[data-r-atelier]', wrap);
    var lastPack = null;
    function show(id) {
      if (!stage) return false;
      var fig = $('[data-r-st="' + id + '"]', stage);
      if (!fig) return false;
      $$('[data-r-st]', stage).forEach(function (f) { f.hidden = f !== fig; });
      var img = $('img', fig); if (img && img.loading === 'lazy') img.loading = 'eager';
      stage.classList.toggle('is-amb', fig.classList.contains('is-amb'));
      if (!fig.classList.contains('is-amb')) {
        lastPack = id;
        $$('[data-r-th]', wrap).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.rTh === String(id) ? 'true' : 'false'); });
        if (atBtn) { atBtn.setAttribute('aria-pressed', 'false'); $('[data-r-atelier-sign]', atBtn).textContent = '+'; }
      }
      return true;
    }
    var cur = $('[data-r-st]:not([hidden])', wrap); if (cur) lastPack = cur.dataset.rSt;
    wrap.addEventListener('click', function (e) {
      var th = e.target.closest('[data-r-th]');
      if (th) { show(th.dataset.rTh); return; }
      var at = e.target.closest('[data-r-atelier]');
      if (at) {
        var on = at.getAttribute('aria-pressed') !== 'true';
        var back = lastPack;
        if (on) { show(at.dataset.rAtelier); lastPack = back; } else if (back) { show(back); }
        at.setAttribute('aria-pressed', on ? 'true' : 'false');
        $('[data-r-atelier-sign]', at).textContent = on ? '−' : '+';
      }
    });
    var qty = $('[data-w-qty-input]', wrap);
    function currentVariant() {
      var opts = $$('[data-w-option]', wrap).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      if (!opts.length) return variants[0];
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function sync() {
      var v = currentVariant();
      var q = Math.max(1, parseInt(qty && qty.value, 10) || 1);
      if (v) $$('[data-r-total]', wrap).forEach(function (el) { el.textContent = formatMoney(v.price * q, money); });
      $$('[data-r-qty]', wrap).forEach(function (el) { el.textContent = q; });
      $$('[data-r-pick]', wrap).forEach(function (b) {
        var fs = $('[data-w-option="' + b.dataset.rPick + '"]', wrap), c = fs && $('input:checked', fs);
        b.setAttribute('aria-pressed', c && c.value === b.dataset.v ? 'true' : 'false');
      });
      var sc = $('[data-r-stage-color]', wrap);
      if (sc) { var fs2 = $('[data-w-option="' + sc.dataset.rStageColor + '"]', wrap), c2 = fs2 && $('input:checked', fs2); if (c2) sc.textContent = c2.value; }
      /* v8.1 : pouces typographiques (″) dans la valeur choisie affichée par wrc.js */
      $$('[data-w-option-value]', wrap).forEach(function (el) { if (el.textContent.indexOf('"') > -1) el.textContent = el.textContent.replace(/"/g, '″'); });
      var main = $('[data-w-atc]', wrap), lab = $('[data-w-atc-label]', wrap), sb = $('.r-sticky__b', wrap), sl = $('[data-r-sticky-label]', wrap);
      if (main && sb) sb.disabled = main.disabled;
      if (lab && sl) sl.textContent = lab.textContent;
      return v;
    }
    if (form) form.addEventListener('change', function (e) {
      if (!e.target.name || e.target.name.indexOf('options[') !== 0) return;
      setTimeout(function () { var v = sync(); if (v && v.featured_media) show(v.featured_media.id); }, 0);
    });
    if (qty) qty.addEventListener('input', sync);
    $$('[data-w-qty]', wrap).forEach(function (b) { b.addEventListener('click', function () { setTimeout(sync, 0); }); });
    wrap.addEventListener('click', function (e) {
      var p = e.target.closest('[data-r-pick]');
      if (!p) return;
      var fs = $('[data-w-option="' + p.dataset.rPick + '"]', wrap);
      var radio = fs && $$('input[type=radio]', fs).find(function (r) { return r.value === p.dataset.v; });
      if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    var lab = $('[data-w-atc-label]', wrap), atc = $('[data-w-atc]', wrap);
    if ('MutationObserver' in window) {
      if (lab) new MutationObserver(function () { sync(); }).observe(lab, { childList: true, characterData: true, subtree: true });
      if (atc) new MutationObserver(function () { sync(); }).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
      var st = $('[data-w-sticky]', wrap);
      /* Complément de l'IntersectionObserver de wrc.js : un saut de défilement (ancre, retour en haut) ne déclenche pas toujours son rappel. */
      if (st && atc) {
        var raf = 0;
        addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var on = atc.getBoundingClientRect().bottom < 0;
            if (on !== st.classList.contains('is-on')) { st.classList.toggle('is-on', on); st.setAttribute('aria-hidden', !on); }
          });
        }, { passive: true });
      }
      if (st) new MutationObserver(function () {
        var on = st.classList.contains('is-on');
        $$('button', st).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
        document.documentElement.classList.toggle('r-sticky-on', on);
      }).observe(st, { attributes: true, attributeFilter: ['class'] });
    }
    sync();
    /* « Va bien avec » : ajout direct d'un produit sans variante */
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-r-add]');
      if (!b || b.disabled) return;
      b.disabled = true;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.rAdd, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error(); return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          $$('[data-w-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.dataset.count = c.item_count; });
          b.textContent = b.dataset.done || b.textContent; b.classList.add('is-done');
        })
        .catch(function () { b.disabled = false; });
    });
  }

  /* ---------- v8.1 · Calculateur de taille : curseur (remplissage, graduations, min / max), résultat mis en forme,
     mini-règle de la plage conseillée, lien vers la collection de l'outil (filtrée par la taille si le filtre existe).
     Le moteur reste wrc.js (data-w-fit) : ici on lit son état (curseur, champ, résultat) sans le modifier. ---------- */
  function num(s) { return parseFloat(String(s).replace(',', '.')); }
  function fmtN(n) { return (Math.round(n * 10) / 10).toLocaleString(document.documentElement.lang || 'fr', { maximumFractionDigits: 1 }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function rulesOf(btn) {
    return String(btn.dataset.rules || '').split(/[;\n]/).map(function (l) {
      var m = l.match(/^\s*([\d.]+)\s*-\s*([\d.]+)\s*=\s*(.+)$/);
      if (!m) return null;
      var o = m[3].split('|');
      return { min: +m[1], max: +m[2], out: o[0].trim(), key: (o[1] || '').trim() };
    }).filter(Boolean);
  }
  function toks(s) { var out = [], re = /\{([+-]\d+(?:\.\d+)?)\}/g, m; while ((m = re.exec(s))) out.push(parseFloat(m[1])); return out; }
  function shortLbl(s) { var t = s.split(' · ')[0].split(' (')[0].trim(); return t.length > 14 ? t.split(/\s/)[0] : t; }
  /* Valeurs de filtre « taille » qui correspondent à une clé (« 15 », « 15.5 ») ou à une plage en cm (« 76-81cm »). */
  function fitMatches(form, key) {
    if (!form || !key) return [];
    var range = /^(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)cm$/.exec(key);
    return $$('input[type=checkbox][name^="filter."]', form).filter(function (i) {
      if (i.disabled) return false;
      var v = i.value, m = v.match(/^\s*(\d+(?:[.,]\d+)?)/);
      if (!m) return /^[a-zà-ÿ]/i.test(key) && v.toLowerCase().indexOf(key.toLowerCase()) === 0;
      var n = num(m[1]);
      if (range) {
        var cm = /["″]|inch|zoll|pouce/i.test(v) ? n * 2.54 : n;
        return /cm|["″]|inch|zoll|pouce/i.test(v) && cm >= +range[1] - 0.6 && cm <= +range[2] + 0.6;
      }
      return /^\d+(\.\d+)?$/.test(key) && Math.abs(n - parseFloat(key)) < 0.01 && /["″]|cm|zoll|inch|pouce|^\s*\d+(?:[.,]\d+)?\s*$/i.test(v);
    });
  }
  function filteredUrl(form, inputs) {
    var u = new URL(form.getAttribute('action') || location.pathname, location.href);
    var sb = $('input[name=sort_by]', form); if (sb && sb.value) u.searchParams.set('sort_by', sb.value);
    inputs.forEach(function (i) { u.searchParams.append(i.name, i.value); });
    return u.pathname + u.search;
  }
  function initFit() {
    $$('[data-r-fit]').forEach(function (root) {
      var range = $('input[type=range]', root), numIn = $('[data-w-fit-num]', root), res = $('[data-w-fit-res]', root);
      var big = $('[data-r-big]', root), ruler = $('[data-r-ruler]', root), ticks = $('[data-r-ticks]', root);
      var eMin = $('[data-r-min]', root), eMax = $('[data-r-max]', root), go = $('[data-r-fit-go]', root), goT = $('[data-r-fit-go-t]', root);
      var pick = $('[data-w-fit-pick]', root);
      if (!range || !res) return;
      var urls = {};
      String(root.dataset.rUrls || '').split(';').forEach(function (kv) { var i = kv.indexOf('='); if (i > 0) urls[kv.slice(0, i)] = kv.slice(i + 1); });
      var form = $('[data-r-filters]'), lastScale = '';
      function active() { return $('.r-seg button[aria-pressed="true"]', root) || $('.r-seg button', root); }
      function fill() {
        var mn = +range.min, mx = +range.max, v = +range.value;
        range.style.setProperty('--p', (mx > mn ? (v - mn) / (mx - mn) * 100 : 0) + '%');
        var sc = mn + '|' + mx;
        if (sc === lastScale) return;
        lastScale = sc;
        if (ticks) {
          var st = mx - mn >= 20 ? 5 : 1, h = '';
          for (var t = Math.ceil(mn / st) * st; t <= mx + 1e-9; t += st) h += '<i style="left:' + ((t - mn) / (mx - mn) * 100).toFixed(3) + '%"' + (t % (st * 2) === 0 && st === 5 || st === 1 && t % 5 === 0 ? ' class="is-l"' : '') + '></i>';
          ticks.innerHTML = h;
        }
        if (eMin) eMin.textContent = fmtN(mn) + ' cm';
        if (eMax) eMax.textContent = fmtN(mx) + ' cm';
      }
      function fitBig() {
        if (!big) return;
        big.style.fontSize = '';
        var fs = parseFloat(getComputedStyle(big).fontSize), w = big.clientWidth, guard = 0;
        while (guard++ < 12 && fs > 32 && (big.scrollWidth > w + 1 || big.offsetHeight > fs * 2.1)) { fs -= 4; big.style.fontSize = fs + 'px'; }
      }
      function paint() {
        fill();
        var btn = active(); if (!btn) return;
        var txt = (res.textContent || '').trim();
        if (big) {
          var parts = txt.split(' · '), main = parts.shift();
          var html = esc(main).replace(/(\d)\s?(cm)\b/g, '$1<span class="r-fit__u">$2</span>');
          if (parts.length) html += '<span class="r-fit__s">' + esc(parts.join(' · ')) + '</span>';
          big.innerHTML = html;
          big.classList.toggle('is-empty', txt === '—' || txt === '');
          fitBig();
        }
        /* Mini-règle */
        var rules = rulesOf(btn), step = num(btn.dataset.step) || 1, raw = num(numIn ? numIn.value : range.value);
        var v = btn.dataset.round === 'up' ? Math.ceil(raw - 1e-9) : Math.round(raw / step) * step;
        var html2 = '', key = '', ok = !isNaN(raw) && txt !== '—';
        if (ruler && rules.length) {
          var cont = rules.some(function (r) { return /\{[+-]/.test(r.out); });
          if (cont) {
            var tk = toks(rules[0].out), t0 = tk[0] || 0, t1 = tk[tk.length - 1] || 0;
            var lo = +btn.dataset.min + t0, hi = +btn.dataset.max + t1, span = hi - lo || 1;
            var a = Math.max(lo, Math.min(hi, v + t0)), b = Math.max(lo, Math.min(hi, v + t1));
            var stp = span >= 20 ? 5 : 1, tks = '';
            for (var t = Math.ceil(lo / stp) * stp; t <= hi + 1e-9; t += stp) tks += '<i class="r-ruler__k" style="left:' + ((t - lo) / span * 100).toFixed(3) + '%"></i>';
            html2 = '<div class="r-ruler__t">' + tks + (ok ? '<i class="r-ruler__b' + (a === b ? ' is-pt' : '') + '" style="left:' + ((a - lo) / span * 100).toFixed(3) + '%;width:' + ((b - a) / span * 100).toFixed(3) + '%"></i>' : '') + '</div>'
              + '<div class="r-ruler__l"><span>' + fmtN(lo) + ' cm</span><span>' + fmtN(hi) + ' cm</span></div>';
            if (ok) key = t0 === t1 ? String(Math.round((v + t0) * 10) / 10) : (Math.round((v + t0) * 10) / 10) + '-' + (Math.round((v + t1) * 10) / 10) + 'cm';
          } else {
            var keyed = rules.filter(function (r) { return r.key; }), n = keyed.length;
            if (n > 1) {
              var cur = rules.find(function (r) { return v >= r.min && v <= r.max; }), i0 = -1, i1 = -1;
              if (ok && cur) {
                if (cur.key) { i0 = i1 = keyed.indexOf(cur); key = cur.key; }
                else {
                  keyed.forEach(function (r, i) { if (r.max < cur.min) i0 = i; if (i1 < 0 && r.min > cur.max) i1 = i; });
                  if (i0 < 0) i0 = i1; if (i1 < 0) i1 = i0;
                  key = i0 >= 0 ? keyed[i0].key : '';
                }
              }
              var tk2 = '';
              for (var k = 0; k <= n; k++) tk2 += '<i class="r-ruler__k" style="left:' + (k / n * 100).toFixed(3) + '%"></i>';
              html2 = '<div class="r-ruler__t">' + tk2 + (i0 >= 0 ? '<i class="r-ruler__b" style="left:' + (i0 / n * 100).toFixed(3) + '%;width:' + ((i1 - i0 + 1) / n * 100).toFixed(3) + '%"></i>' : '') + '</div>'
                + '<div class="r-ruler__l"><span>' + esc(shortLbl(keyed[0].out)) + '</span><span>' + esc(shortLbl(keyed[n - 1].out)) + '</span></div>';
            }
          }
          ruler.innerHTML = html2;
          ruler.hidden = !html2;
        }
        if (pick && pick.textContent.indexOf('"') > -1) pick.textContent = pick.textContent.replace(/"/g, '″');
        /* Lien « Voir les … de cette taille » */
        if (go) {
          var tool = btn.dataset.tool || '', url = urls[tool], lbl = tool && root.dataset['l' + tool.charAt(0).toUpperCase() + tool.slice(1)];
          var show = !!(url && lbl && ok);
          if (show && pick && !pick.hidden) show = false;
          if (show) {
            var here = form && new URL(form.getAttribute('action'), location.href).pathname === new URL(url, location.href).pathname;
            if (here) {
              var m = fitMatches(form, key);
              if (m.length) go.href = filteredUrl(form, m); else show = false;
            } else {
              go.href = url + (key ? (url.indexOf('?') < 0 ? '?' : '&') + 'r_fit=' + encodeURIComponent(key) : '');
            }
          }
          if (goT && lbl) goT.textContent = lbl;
          go.hidden = !show;
        }
      }
      range.addEventListener('input', paint);
      if (numIn) numIn.addEventListener('input', function () { setTimeout(paint, 0); });
      $$('.r-seg button', root).forEach(function (b) { b.addEventListener('click', function () { setTimeout(paint, 0); }); });
      if ('MutationObserver' in window) new MutationObserver(function () { paint(); }).observe(res, { childList: true, characterData: true, subtree: true });
      addEventListener('resize', function () { fitBig(); }, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitBig);
      paint();
    });
  }

  /* ---------- v8.1 · Filtres de collection : menus déroulants (bureau), panneau latéral / tiroir plein écran,
     nombre de produits en direct sur « Voir N produits », lien ?r_fit= du calculateur ---------- */
  function initFilters() {
    var form = $('[data-r-filters]');
    if (!form) return;
    var groups = $$('[data-r-fg]', form), scrim = $('[data-w-filters-scrim]'), apply = $('[data-r-apply]', form);
    var desk = matchMedia('(min-width: 900px)');
    var isOpen = function () { return form.classList.contains('is-open'); };
    /* Lien du calculateur : ?r_fit=15 ou ?r_fit=76-81cm → coche les valeurs correspondantes */
    var q = new URLSearchParams(location.search), rf = q.get('r_fit');
    if (rf) {
      var m = fitMatches(form, rf);
      if (m.length) { location.replace(filteredUrl(form, m)); return; }
      q.delete('r_fit'); history.replaceState({}, '', location.pathname + (q.toString() ? '?' + q : '') + location.hash);
    }
    groups.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open || isOpen()) return;
        groups.forEach(function (o) { if (o !== d) o.open = false; });
        var p = $('.r-fg__p', d); if (!p) return;
        p.style.removeProperty('--sx');
        var r = p.getBoundingClientRect(), over = r.right - (document.documentElement.clientWidth - 16);
        if (over > 0) p.style.setProperty('--sx', -over + 'px');
      });
    });
    document.addEventListener('click', function (e) {
      if (isOpen() || e.target.closest('[data-r-fg]')) return;
      groups.forEach(function (d) { d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || isOpen()) return;
      var o = groups.find(function (d) { return d.open; });
      if (o) { o.open = false; $('summary', o).focus(); }
    });
    function sync() {
      var on = isOpen();
      if (scrim) scrim.hidden = !on;
      document.documentElement.classList.toggle('w-lock', on);
      document.documentElement.classList.toggle('r-filters-on', on);
      if (on) {
        var any = false;
        groups.forEach(function (d) { d.open = d.classList.contains('is-active'); any = any || d.open; });
        if (!any && groups[0] && desk.matches) groups[0].open = true;
      } else {
        groups.forEach(function (d) { d.open = false; });
      }
    }
    if ('MutationObserver' in window) new MutationObserver(sync).observe(form, { attributes: true, attributeFilter: ['class'] });
    /* Panneau ouvert : pas de rechargement à chaque case, le nombre de produits se met à jour sur le bouton */
    var tm = 0, ctl = null;
    function count() {
      if (!apply) return;
      var u = new URL(form.getAttribute('action'), location.href);
      new FormData(form).forEach(function (v, k) { if (v !== '') u.searchParams.append(k, v); });
      u.searchParams.set('section_id', form.dataset.rSection);
      if (ctl && ctl.abort) ctl.abort();
      ctl = 'AbortController' in window ? new AbortController() : null;
      apply.setAttribute('aria-busy', 'true');
      fetch(u.pathname + u.search, { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined }).then(function (r) { return r.text(); }).then(function (h) {
        var mm = h.match(/data-r-count="(\d+)"/);
        if (mm) { var n = +mm[1]; apply.textContent = (n === 1 ? apply.dataset.one : apply.dataset.other).replace('[n]', n); }
        apply.removeAttribute('aria-busy');
      }).catch(function () { apply.removeAttribute('aria-busy'); });
    }
    document.addEventListener('change', function (e) {
      if (!isOpen() || !form.contains(e.target)) return;
      e.stopPropagation();
      clearTimeout(tm); tm = setTimeout(count, 200);
    }, true);
    form.addEventListener('input', function (e) { if (isOpen() && e.target.type === 'number') { clearTimeout(tm); tm = setTimeout(count, 500); } });
  }

  function init() { initMore(); initProduct(); initFit(); initFilters(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
